import { render, staticRenderFns } from "./AdvertisementSettings.vue?vue&type=template&id=5aa79e0c&scoped=true&"
import script from "./AdvertisementSettings.vue?vue&type=script&lang=js&"
export * from "./AdvertisementSettings.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisementSettings.vue?vue&type=style&index=0&id=5aa79e0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa79e0c",
  null
  
)

export default component.exports